import { useMediaQuery } from './use-media-query';

export type Breakpoint = 'mobile' | 'tablet' | 'desktop';

/**
 * Identify breakpoint of the current screen size
 * WARNING: Do not use this hook's output to conditionally render as it will cause screen jumps on desktop. As this hook defaults to mobile first, you will see mobile renders first and then desktop renders. Instead, use this hook only to determine functionality between various screen sizes.
 * @returns
 */
export function useBreakpoint(): Breakpoint {
  const isMobile = useMediaQuery('(min-width: 640px)');
  const isTablet = useMediaQuery('(min-width: 768px)');
  const isDesktop = useMediaQuery('(min-width: 1024px)');

  if (isDesktop) return 'desktop';
  if (isTablet) return 'tablet';
  if (isMobile) return 'mobile';

  return 'mobile';
}
